import React, { useRef, useState } from "react";
import { useThemeMode } from "hooks/useThemeMode";
import { darkPalette } from "helpers/themeColors";
import { useSearch } from "hooks/useSearch";
import { Typography } from "@material-ui/core";
import { grey, green, blue } from "@material-ui/core/colors";

export const DragAndDropBox = ({ fileProcessor, documentType, infoType }) => {
  const { isDark } = useThemeMode();
  const { setSnackbar } = useSearch();
  const fileInputRef = useRef(null);
  const [onDrag, setOnDrag] = useState(false);

  const handleFileInputChange = (event) => {
    try {
      const files = Object.values(event.target.files);
      documentType
        ? files.map((file) => fileProcessor(file, infoType))
        : files.map((file) => fileProcessor(file));
    } catch (error) {
      return setSnackbar("Error al procesar el archivo");
    }
  };

  const handleButtonClick = () => {
    fileInputRef.current.click();
  };

  const handleDragOver = (event) => {
    event.preventDefault();
    setOnDrag(true);
  };

  const handleDragEnd = () => {
    setOnDrag(false);
  };

  const handleDrop = (event) => {
    event.preventDefault();
    setOnDrag(false);
    const files = event.dataTransfer.files;
    const filesArray = Array.from(files);
    filesArray.map((file) => fileProcessor(file));
  };

  return (
    <div
      onDragOver={handleDragOver}
      onDragEnd={handleDragEnd}
      onDrop={handleDrop}
      style={{
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
        flexDirection: "column",
        gap: 8,
        backgroundColor: isDark ? darkPalette.altRowBg : grey[200],
        boxShadow: `0 0 5px 0px ${onDrag ? green[500] : isDark ? darkPalette.border : grey[50]}`,
        width: "100%",
        height: 150,
        margin: "0 auto",
        border: `2px dashed ${onDrag ? blue[100] : isDark ? "#555" : green[100]}`,
      }}
    >
      {onDrag ? (
        <Typography variant="h5">Suelta el archivo aquí</Typography>
      ) : (
        <Typography style={{ textAlign: "center" }}>
          Arrastra o carga los archivos dando click
          <Typography
            onClick={handleButtonClick}
            component="a"
            style={{
              marginLeft: 4,
              color: blue[500],
              textDecoration: "none",
              cursor: "pointer",
            }}
          >
            aqui
          </Typography>
        </Typography>
      )}
      <input
        type="file"
        id="fileInput"
        style={{ display: "none" }}
        onChange={handleFileInputChange}
        ref={fileInputRef}
        multiple
      />
    </div>
  );
};
